import { render, staticRenderFns } from "./hook_init.vue?vue&type=template&id=0c9919e4"
import script from "./hook_init.vue?vue&type=script&lang=js"
export * from "./hook_init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports